import React, { useState, useEffect, useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { connect } from 'react-redux';
import { dutyAssignAPI } from '../../../../apis';
import Results from '../Results';
import { i18n } from '../../../../language';
import DiaLog from '../../../../components/Dialog';
import { CategoryEditTable } from '../Table';
import { ChatroomCategoryToolBar } from '../ToolBar';
import { updateUserRoleAction } from '../../../../redux/actions/userRole';

import PopEdit from './PopEdit';

const useStyles = makeStyles((theme) => ({
  results: {
    padding: '1.875rem',
  },
}));

function ChatCategory({ loginInfo, userRole, updateUserRole, rouList, roleMap }) {
  const classes = useStyles();

  const selectList = [];

  const refPopEdit = useRef();

  // WardTable
  const [RoleList, setRoleList] = useState([]);
  const [openErrorDiaLog, setOpenErrorDiaLog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [confirmDeleteDiaLog, setConfirmDeleteDiaLog] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');
  const deleteCategory = useRef(null);

  const getSysRoleList = async () => {
    try {
      const { result } = await dutyAssignAPI.getDaDutyChatCategoryList();
      setRoleList(result);
      const categorys = [...new Set(result.map((el) => el.category))].sort((a, b) => a.localeCompare(b));
      refPopEdit.current.setCategoryOptions(categorys);
    } catch (error) {
      setRoleList([]);
      console.log('------Role error------', error);
    }
  };

  useEffect(() => {
    if (loginInfo.flag) {
      (async () => {
        await getSysRoleList();
      })();
    }
  }, []);

  const handleErrorMessage = (errors) => {
    let errorArray = [];
    errors.forEach((element, index) => {
      if (element?.key === 'subCategoryNameDuplicate') {
        errorArray.push(`${index + 1}. ${i18n.t('DUTYASSIGN_ROSTER_SETTING_ERROR_CATEGORY_EXIST')}.`);
      }
      if (element?.key === 'corpIdInvalid') {
        errorArray.push(`${index + 1}. ${i18n.t('DUTYASSIGN_ROSTER_SETTING_ERROR_CORPID_INVALID')}.`);
      }
      if (element?.key === 'haChatAccountInvalid') {
        errorArray.push(`${index + 1}. ${i18n.t('DUTYASSIGN_ROSTER_SETTING_ERROR_CORPID_NOT_REGISTER')}.`);
      }
    });
    setErrorMessage(errorArray);
    setOpenErrorDiaLog(true);
  };

  const addClick = () => {
    refPopEdit.current.init();
    refPopEdit.current.setDialogTitle(i18n.t('DUTYASSIGN_ROSTER_SETTING_ADD_CATEGORY_TITLE'));
    refPopEdit.current.setOnConfirm((item) => {
      dutyAssignAPI.saveDaDutyChatCategory(item).then(({ result }) => {
        const { errors } = result;
        if (errors?.length > 0) {
          handleErrorMessage(errors);
          return;
        }
        getSysRoleList();
        refPopEdit.current.close();
      });
    });
    refPopEdit.current.open();
  };

  const editClick = (item, index) => {
    refPopEdit.current.init();
    refPopEdit.current.setRowValue(item);
    refPopEdit.current.setDialogTitle(i18n.t('DUTYASSIGN_ROSTER_SETTING_EDIT_CATEGORY_TITLE'));
    refPopEdit.current.setOnConfirm((item) => {
      dutyAssignAPI.saveDaDutyChatCategory(item).then(({ result }) => {
        const { errors } = result;
        if (errors?.length > 0) {
          handleErrorMessage(errors);
          return;
        }
        getSysRoleList();
        refPopEdit.current.close();
      });
    });
    refPopEdit.current.open();
  };

  const deleteClick = (item, index) => {
    deleteCategory.current = item;
    setDeleteMessage([
      `${i18n.t('DUTYASSIGN_ROSTER_SETTING_DELETE_MSG')}: #${index + 1}`,
      `${i18n.t('DUTYASSIGN_CREATE_CHATROOM_CATEGORY_TITLE')}: ${item.category}`,
      `${i18n.t('DUTYASSIGN_ROSTER_SETTING_SUBCATEGORY_TITLE')}: ${item.subCategory}`,
    ]);
    setConfirmDeleteDiaLog(true);
  };

  const [keyword, setKeyword] = useState('');
  const ShowDATA = useMemo(() => {
    let searchRes = [];
    if (keyword === '' || keyword === null || keyword === undefined) {
      searchRes = RoleList;
    } else {
      const lkeyword = keyword.toLowerCase();
      searchRes = _.filter(RoleList, (o) => {
        return (
          o.category.toLowerCase().indexOf(lkeyword) > -1 ||
          o.subCategory.toLowerCase().indexOf(lkeyword) > -1 ||
          `${o.ccCorpId || ''}`.toLowerCase().indexOf(lkeyword) > -1
        );
      });
    }
    return searchRes;
  }, [RoleList, keyword]);

  return (
    <>
      {openErrorDiaLog ? (
        <DiaLog
          open={openErrorDiaLog}
          id="DutyAssign-DiaLog-aik"
          confirm={i18n.t('EQUIPMENT_CONFIRM_OK')}
          title={i18n.t('DUTYASSIGN_ROSTER_SETTING_ERROR_TITLE')}
          handleCancel={() => {
            setOpenErrorDiaLog(false);
          }}
          handleClose={() => {
            setOpenErrorDiaLog(false);
          }}
          handleConfirm={() => {
            setOpenErrorDiaLog(false);
          }}
        >
          <div style={{ margin: 0 }}>
            {errorMessage?.map((msg) => {
              return (
                <p style={{ margin: 2, width: '97%', wordWrap: 'break-word', wordBreak: 'break-all' }} key={msg}>
                  {msg}
                </p>
              );
            })}
          </div>
        </DiaLog>
      ) : null}

      {confirmDeleteDiaLog ? (
        <DiaLog
          open={confirmDeleteDiaLog}
          id="DutyAssign-DiaLog-aik"
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          title={i18n.t('DUTYASSIGN_ROSTER_SETTING_DELETE_CATEGORY_TITLE')}
          dialogheadStyle={{ marginBottom: 10 }}
          dialogfootStyle={{ marginTop: 15 }}
          handleCancel={() => {
            setConfirmDeleteDiaLog(false);
          }}
          handleClose={() => {
            setConfirmDeleteDiaLog(false);
          }}
          handleConfirm={() => {
            setConfirmDeleteDiaLog(false);
            dutyAssignAPI.deleteDaDutyChatCategoryList(deleteCategory?.current).then(({ result }) => {
              const { errors } = result;
              if (errors?.length > 0) {
                handleErrorMessage(errors);
                return;
              }
              getSysRoleList();
              refPopEdit.current.close();
            });
          }}
        >
          <div style={{ margin: 0 }}>
            {deleteMessage?.map((msg) => {
              return (
                <p style={{ margin: 10, width: '97%', wordWrap: 'break-word', wordBreak: 'break-all' }} key={msg}>
                  {msg}
                </p>
              );
            })}
          </div>
        </DiaLog>
      ) : null}
      <ChatroomCategoryToolBar
        addClick={addClick}
        searchClick={(val) => {
          setKeyword(val);
        }}
        onChange={_.debounce((val) => {
          setKeyword(val);
        }, 500)}
        selectList={selectList}
      />
      <Results length={ShowDATA ? ShowDATA.length : 0} className={classes.results} />
      <CategoryEditTable
        editClick={editClick}
        deleteClick={deleteClick}
        deleteDisabledFunc={(item, index) => item.deleteDisabled === 1}
        allData={ShowDATA}
      />
      <PopEdit ref={refPopEdit} />
    </>
  );
}

export default connect(
  (state) => ({
    userRole: state.userRole,
    loginInfo: state.loginInfo,
    rouList: state.rouList,
    roleMap: state.roleMap,
  }),
  {
    updateUserRole: updateUserRoleAction,
  }
)(ChatCategory);
